import { BoxProps, Box, makeStyles } from '@material-ui/core';
import React from 'react';

export type PageBoxProps = BoxProps & {

}

export function PageBox (props: PageBoxProps) {
    const cls = useStyles();

    return (
        <Box className={cls.root} {...props} />
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    }
}))